import React, { useState, useEffect } from "react";
import Sidebar from "../../Component/Sidebar";
import DashboardHeader from "../../Component/DashboardHeader";
import QuickStatsSection from "../../Component/QuickStatsSection";
import UpcomingScheduleSection from "../../Component/UpcomingScheduleSection";
import SessionsPerDayChart from "../../Component/SessionsPerDayChart";
import SessionsByModeChart from "../../Component/SessionsByModeChart";
import RiskStatusCard from "../../Component/RiskStatusCard/RiskStatusCard";
import RecentBookedTable from "../../Component/RecentBookedTable/RecentBookedTable";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfile } from "../../redux/action/Profile";
import { navigateTo } from "../../utils/navigation";

export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const dispatch = useDispatch();
  const { user, userLoading } = useSelector((state) => state.GET_USER_PROFILE);

  useEffect(() => {
    dispatch(getUserProfile());
  }, []);

  const profileIncomplete = !userLoading && user?.profileUpdate === true;

  return (
    <div className="relative flex min-h-screen bg-[#F8FAFC] mt-[80px]">
      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-[calc(100vh/var(--app-zoom))] z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>

      <div
        className={`flex-1 min-w-0 bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
          }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] rounded-2xl">
          {/* Top Section: Welcome + Stats + Schedule */}
          <div className="flex flex-col xl:flex-row gap-3">
            {/* Left Side */}
            <div className="flex-1 min-w-0">
              <DashboardHeader />

              <div className="mt-1">
                <QuickStatsSection />
              </div>
            </div>

            {/* Right Side */}
            <div className="relative w-full xl:w-[340px] 2xl:w-[380px] flex-shrink-0 bg-[#ffffff]">
              <UpcomingScheduleSection />
            </div>
          </div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 p-0 mt-0">
            <SessionsPerDayChart />

            <SessionsByModeChart />
          </div>
          <div className="p-0 mt-3 bg-white  flex flex-col md:flex-row gap-3">
            <RiskStatusCard />
            <RecentBookedTable />
          </div>
        </div>
      </div>

      {/* Profile Completion Modal */}
      {profileIncomplete && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-md mx-4 p-8 font-poppins">
            <div className="flex flex-col items-center text-center gap-4">
              <div className="w-16 h-16 rounded-full bg-[#EFF6FF] flex items-center justify-center">
                <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4B61FF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <circle cx="12" cy="8" r="4" />
                  <path d="M4 20c0-4 3.6-7 8-7s8 3 8 7" />
                </svg>
              </div>
              <h2 className="text-xl font-semibold text-[#171717]">
                Complete Your Profile
              </h2>
              <p className="text-[#334155] text-sm leading-relaxed">
                Your profile is incomplete. Please complete your profile to be visible to users for booking sessions.
              </p>
              <button
                onClick={() => navigateTo("/profile")}
                className="w-full btn-gradient text-white font-semibold py-3 rounded-xl"
              >
                Complete Profile Now
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
